<template>
  <a-modal
    title="新增科目管理"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="字典类型主表id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入字典类型主表id" v-decorator="['dictId', {rules: [{required: true, message: '请输入字典类型主表id！'}]}]" />
        </a-form-item>
        <a-form-item
          label="父级id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入父级id" v-decorator="['parentId', {rules: [{required: true, message: '请输入父级id！'}]}]" />
        </a-form-item>
        <a-form-item
          label="字典明细值"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入字典明细值" v-decorator="['detailValue', {rules: [{required: true, message: '请输入字典明细值！'}]}]" />
        </a-form-item>
        <a-form-item
          label="字典明细名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入字典明细名称" v-decorator="['detailName', {rules: [{required: true, message: '请输入字典明细名称！'}]}]" />
        </a-form-item>
        <a-form-item
          label="字典明细介绍"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入字典明细介绍" v-decorator="['detailDesc', {rules: [{required: true, message: '请输入字典明细介绍！'}]}]" />
        </a-form-item>
        <a-form-item
          label="拼音"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入拼音" v-decorator="['pinyin', {rules: [{required: true, message: '请输入拼音！'}]}]" />
        </a-form-item>
        <a-form-item
          label="排序值"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入排序值" v-decorator="['seqno', {rules: [{required: true, message: '请输入排序值！'}]}]" />
        </a-form-item>
        <a-form-item
          label="创建时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择创建时间" v-decorator="['ctstamp',{rules: [{ required: true, message: '请选择创建时间！' }]}]" @change="onChangectstamp"/>
        </a-form-item>
        <a-form-item
          label="修改时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择修改时间" v-decorator="['utstamp',{rules: [{ required: true, message: '请选择修改时间！' }]}]" @change="onChangeutstamp"/>
        </a-form-item>
        <a-form-item
          label="是否启用（0:禁用，1:启用）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入是否启用（0:禁用，1:启用）" v-decorator="['useflag', {rules: [{required: true, message: '请输入是否启用（0:禁用，1:启用）！'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import { baDatadictDetailAdd } from '@/api/modular/interhospital/deptClass/deptClassManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        ctstampDateString: '',
        utstampDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      // 初始化方法
      add (record) {
        this.visible = true
      },
      /**
       * 提交表单
       */
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.ctstamp = this.ctstampDateString
            values.utstamp = this.utstampDateString
            baDatadictDetailAdd(values).then((res) => {
              if (res.success) {
                this.$message.success('新增成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('新增失败')// + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      onChangeutstamp(date, dateString) {
        this.utstampDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
